// extracted by mini-css-extract-plugin
module.exports = {"recipe-aside":"AsideRecipes_recipe-aside__WiJSv","date":"AsideRecipes_date__hTTDN","title":"AsideRecipes_title__3P9ZE","image":"AsideRecipes_image__37G3w"};